import { getGroupNoWithBearerAuth } from '@doda/common/src/services/getGroupNoWithBearerAuthAPI';
import { LocalStorageUtil } from '@doda/common/src/utils/localStorageUtil';
import { tlReadyExecute } from '@doda/common/src/utils/adobeAnalyticsUtil';

import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import {
  adobeAnalyticsScriptsSelector,
  AnalyticsSliceState,
} from '../../redux/features/analytics';

/**
 * お知らせカウ予約訴求施策のAB振分けを取得する
 * @returns {number} groupNo
 */
export const getWeb2NotificationCounselingAbGroupNo = () => {
  return getGroupNoWithBearerAuth('web2_notification_counseling');
};

/**
 * お知らせカウ予約訴求AB対象者の場合はtrue
 * @returns {boolean}
 */
export const isWeb2NotificationCounselingAbTarget = () => {
  const result = getOshiraseCounseling();
  return Boolean(result);
};

/**
 * カウンセリング予約判定結果をlocalStorageにセットする
 * @param counselingShow
 */
export const setOshiraseCounseling = (counselingShow: boolean) => {
  LocalStorageUtil.setItem('oshirase_counseling', counselingShow);
};

/**
 * カウンセリング予約判定結果をlocalStorageから取得する
 * @returns {boolean}
 */
const getOshiraseCounseling = () => {
  return LocalStorageUtil.getItem('oshirase_counseling');
};

/**
 * DODASITE-4367 お知らせ内スカウト風訴求 AB振分け計測処理
 * @param groupNo - AB振分けグループNo
 * @returns AB振分けの計測発火
 */
export const measureNotificationCounselingABAA = <
  State extends AnalyticsSliceState,
>(
  groupNo: string
) => {
  return (
    dispatch: ThunkDispatch<State, unknown, Action>,
    getState: () => State
  ) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    if (groupNo === '2') {
      tlReadyExecute(
        isAdobeScript,
        dispatch,
        'oshirase_counseling_imp_test',
        {}
      );
    } else if (groupNo === '1') {
      tlReadyExecute(
        isAdobeScript,
        dispatch,
        'oshirase_counseling_imp_original',
        {}
      );
    }
  };
};
